import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // adjust path if needed

export default function PublicRoute({ children }) {
  const { user } = useAuth();

  // If user is logged in, redirect to dashboard
  if (user) return <Navigate to="/dashboard" replace />;

  return children;
}